<template>
  <div class="full-height">
    <q-card class="full-width full-height">
      <q-card-actions class="bg-accent text-white q-pa-md">
        <div class="title">#{{ formData.id }}: {{ solutionCardTitle }}</div>
        <q-space></q-space>
        <q-btn
          :loading="isLoading"
          style="width: 100px; background-color: #6dbf50"
          class="q-mr-sm sustainability-button"
          @click="saveAndAddNew"
        >
          Save & Add New
        </q-btn>
        <q-btn
          :loading="isLoading"
          color="primary"
          style="width: 100px"
          class="q-mr-sm sustainability-button"
          @click="saveSolution(true)"
        >
          Save & Close
        </q-btn>

        <q-btn @click="closeDialog" flat icon="mdi-close" size="5" round />
      </q-card-actions>
      <q-card-section class="q-pa-none">
        <q-tabs v-model="tab" align="left">
          <q-tab v-for="(tabItem, i) in tabsList" :key="i" :name="tabItem.name">
            <div style="display: inline">
              <span class="tabTitle">{{ tabItem.label }} </span>
              <q-icon
                name="mdi-alert-circle"
                color="red"
                v-if="tabItem.isError"
              >
              </q-icon>
            </div>
          </q-tab>
        </q-tabs>

        <q-tab-panels v-model="tab" animated keep-alive ref="tabs">
          <!--GENERAL-->
          <q-tab-panel name="general">
            <div class="row q-col-gutter-x-lg q-col-gutter-y-md">
              <div class="col-12">
                <q-card bordered flat>
                  <q-card-section>
                    <div class="row q-mb-sm items-center">
                      <div class="col-6">
                        <div class="row items-center q-col-gutter-x-md">
                          <div class="col-3">
                            <div class="title q-my-none">Info</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <q-form ref="form">
                      <div
                        class="row q-col-gutter-y-sm q-mb-lg q-col-gutter-x-lg"
                      >
                        <div class="col-6">
                          <div
                            v-if="
                              (changeImage || !formData.imageUrl) && formData.id
                            "
                            style="margin: auto; width: 200px"
                          >
                            <croppa
                              ref="imgCroppa"
                              :height="200"
                              :width="300"
                              v-model="myCroppa"
                              remove-button-color="#68c6d2"
                              :show-loading="true"
                              :loading-size="50"
                              crossOrigin="anonymous"
                              :quality="2"
                              :prevent-white-space="false"
                            ></croppa>
                            <span class="text-caption"
                              >Recommended .jpg/.jpeg files and ideally 500Kb
                            </span>
                          </div>
                          <div v-else style="margin: auto; width: 300px">
                            <q-img
                              :src="formData.imageUrl"
                              style="width: 300px; height: 200px"
                              v-if="formData.id"
                            >
                            </q-img>
                            <q-btn
                              :disable="formData.progressStatus == 'green'"
                              class="full-width"
                              color="primary"
                              label="Change"
                              @click="changeImage = true"
                              v-if="formData.id"
                            >
                            </q-btn>
                            <span class="text-caption"
                              >Recommended .jpg/.jpeg files and ideally 500Kb
                            </span>
                          </div>
                        </div>
                        <div class="col-6"></div>

                        <div class="col-6">
                          <q-input
                            :disable="formData.progressStatus == 'green'"
                            @blur="changeSolutionCardTitle(formData.title)"
                            v-model="formData.title"
                            label="Solution Title"
                            :rules="[(v) => !!v || 'Title is Required']"
                          ></q-input>
                        </div>

                        <div class="col-3">
                          <q-select
                            label="Progress Status"
                            @input="lockWarning"
                            v-model="formData.progressStatus"
                            :options="progressStatusOptions"
                            map-options
                            option-value="color"
                            option-label="label"
                            emit-value
                          >
                            <template v-slot:option="scope">
                              <q-item
                                dense
                                clickable
                                :active="scope.selected"
                                active-class="bg-primary"
                                @click="scope.toggleOption(scope.opt)"
                                v-bind="scope.itemProps"
                                v-on="scope.progressStatusOptions"
                              >
                                <q-item-section avatar>
                                  <q-avatar>
                                    <q-img
                                      :style="`background-color: ${scope.opt.color};width: 20px;height: 20px; border-radius: 100px;`"
                                    ></q-img>
                                  </q-avatar>
                                </q-item-section>
                                <q-item-section side style="color: black">
                                  {{ scope.opt.description }}
                                </q-item-section>
                              </q-item>
                            </template>
                            <template v-slot:selected-item="scope">
                              <div class="row items-center">
                                <q-img
                                  class="q-mr-md"
                                  :style="`background-color: ${scope.opt.color};width: 20px;height: 20px; border-radius: 100px;`"
                                ></q-img>
                                {{ scope.opt.description }}
                              </div>
                            </template>
                          </q-select>
                        </div>
                        <div class="col-3">
                          <q-select
                            label="Image Status"
                            @input="lockWarning"
                            v-model="formData.imageStatus"
                            :options="imageStatusOptions"
                            map-options
                            option-value="color"
                            option-label="label"
                            emit-value
                          >
                            <template v-slot:option="scope">
                              <q-item
                                dense
                                clickable
                                :active="scope.selected"
                                active-class="bg-primary"
                                @click="scope.toggleOption(scope.opt)"
                                v-bind="scope.itemProps"
                                v-on="scope.imageStatusOptions"
                              >
                                <q-item-section avatar>
                                  <q-avatar>
                                    <q-img
                                      :style="`background-color: ${scope.opt.color};width: 20px;height: 20px; border-radius: 100px;`"
                                    ></q-img>
                                  </q-avatar>
                                </q-item-section>
                                <q-item-section side style="color: black">
                                  {{ scope.opt.description }}
                                </q-item-section>
                              </q-item>
                            </template>
                            <template v-slot:selected-item="scope">
                              <div class="row items-center">
                                <q-img
                                  class="q-mr-md"
                                  :style="`background-color: ${scope.opt.color};width: 20px;height: 20px; border-radius: 100px;`"
                                ></q-img>
                                {{ scope.opt.description }}
                              </div>
                            </template>
                          </q-select>
                        </div>

                        <div class="col-12 col-md-8">
                          <q-select
                            :disable="formData.progressStatus == 'green'"
                            v-model="formData.areaOfBusiness"
                            label="Area Of the Business"
                            @filter="filterAreaOfBiz"
                            use-input
                            use-chips
                            :options="filteredAreaOfBizOptions"
                            multiple
                          >
                            <template #before-options>
                              <q-item
                                clickable
                                @click="selectAllAreaOfBiz"
                                :active="isSelectAllAreaOfBiz"
                              >
                                <q-item-section>
                                  <q-item-label>All</q-item-label>
                                </q-item-section>
                              </q-item>
                            </template>
                            <template v-slot:no-option>
                              <q-item>
                                <q-item-section class="text-grey">
                                  No results
                                </q-item-section>
                              </q-item>
                            </template>
                          </q-select>
                        </div>
                        <div class="col-6 col-md-2">
                          <q-checkbox
                            :disable="formData.progressStatus == 'green'"
                            label="Quick Win"
                            v-model="formData.quickWin"
                            :true-value="1"
                            :false-value="0"
                          ></q-checkbox>
                        </div>
                        <div class="col-6 col-md-2">
                          <q-checkbox
                            label="Hide Find tab"
                            v-model="formData.hideFindTab"
                            :true-value="1"
                            :false-value="0"
                          ></q-checkbox>
                        </div>
                        <div class="col-12">
                          <q-select
                            :disable="formData.progressStatus == 'green'"
                            v-model="formData.industry"
                            label="Industry"
                            @filter="filterIndustry"
                            use-input
                            counter
                            use-chips
                            :options="filteredIndustryOptions"
                            multiple
                          >
                            <template #before-options>
                              <q-item
                                clickable
                                @click="selectAllIndustries"
                                :active="isSelectAllIndustries"
                              >
                                <q-item-section>
                                  <q-item-label>All</q-item-label>
                                </q-item-section>
                              </q-item>
                            </template>
                            <template v-slot:no-option>
                              <q-item>
                                <q-item-section class="text-grey">
                                  No results
                                </q-item-section>
                              </q-item>
                            </template>
                          </q-select>
                        </div>
                        <div class="col-12">
                          <q-input
                            :disable="formData.progressStatus == 'green'"
                            label="Description"
                            v-model="formData.description"
                            type="textarea"
                            counter
                            maxlength="150"
                          ></q-input>
                        </div>
                        <div class="col-12">
                          <q-input
                            :disable="formData.progressStatus == 'green'"
                            label="How this will help you?"
                            v-model="formData.help"
                            type="textarea"
                          >
                          </q-input>
                        </div>
                        <div class="col-12">
                          <q-input
                            label="Admin Notes"
                            v-model="formData.adminNotes"
                            type="textarea"
                            class="q-mb-lg"
                          >
                          </q-input>
                        </div>
                        <!-- <div class="col-6">
                          <q-input
                            :disable="formData.progressStatus == 'green'"
                            label="Extra Insights"
                            v-model="formData.extraInsights"
                            type="textarea"
                          ></q-input>
                        </div>
                        <div class="col-6">
                          <q-input
                            :disable="formData.progressStatus == 'green'"
                            label="Extra Insights Override"
                            v-model="formData.extraInsightsOverride"
                            type="textarea"
                          ></q-input>
                        </div> -->
                      </div>
                    </q-form>
                  </q-card-section>
                </q-card>
              </div>
              <!--IMPACT FORMS-->
              <div class="col-12">
                <div class="row q-col-gutter-x-lg">
                  <div class="col-6">
                    <q-card flat bordered class="q-pt-md" style="height: 350px">
                      <q-card-section>
                        <div class="row q-mb-sm items-center">
                          <div class="col-6">
                            <div class="row items-center q-col-gutter-x-md">
                              <div class="col-12">
                                <div class="title q-my-none">Difficulty</div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <q-select
                          label="Select One"
                          :options="rateOptions"
                          v-model="formData.ease"
                        >
                        </q-select>

                        <div class="row q-mb-sm items-center q-mt-lg">
                          <div class="col-6">
                            <div class="row items-center q-col-gutter-x-md">
                              <div class="col-12">
                                <div class="title q-my-none">
                                  Estimated Cost
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        <q-select
                          label="Select One"
                          :options="rateOptions"
                          v-model="formData.cost"
                        >
                        </q-select>
                      </q-card-section>
                    </q-card>
                  </div>
                  <div class="col-6">
                    <q-card flat bordered style="height: 350px">
                      <q-card-section>
                        <div v-if="!isAddingImpact">
                          <div
                            class="row q-col-gutter-x-md q-mb-sm items-center"
                          >
                            <div class="title q-my-none q-mr-sm">
                              Estimated Impact
                            </div>
                            <div>
                              <q-btn
                                color="primary"
                                @click="isAddingImpact = true"
                              >
                                <q-icon name="mdi-plus-circle"> </q-icon>
                                <span
                                  class="sustainability-font q-mx-sm"
                                  style="font-size: 13px"
                                >
                                  Add
                                </span>
                              </q-btn>
                            </div>
                          </div>

                          <div
                            class="row q-col-gutter-x-md items-center q-mb-sm"
                          >
                            <data-table
                              style="height: 280px"
                              headerBgColor="#162c47"
                              headerTextColor="white"
                              :columns="solutionsImpactColumns"
                              :data="solutionsImpactList"
                              flat
                            >
                              <template
                                slot="body-cell-impact"
                                slot-scope="data"
                              >
                                <q-td :props="data.props">
                                  <q-select
                                    dense
                                    :options="rateOptions"
                                    v-model="data.props.row.impact"
                                    @blur="onImpactFieldBlur(data.props.row)"
                                  >
                                  </q-select>
                                </q-td>
                              </template>
                              <template slot="body-cell-rank" slot-scope="data">
                                <q-td :props="data.props">
                                  <q-input
                                    class="actionRank-input"
                                    v-model="data.props.row.rank"
                                    @blur="saveImpact(data.props.row, false)"
                                    dense
                                    label="Rank"
                                  >
                                  </q-input>
                                </q-td>
                              </template>
                              <template
                                slot="body-cell-actions"
                                slot-scope="data"
                              >
                                <q-td :props="data.props">
                                  <q-btn
                                    round
                                    color="red"
                                    flat
                                    icon="mdi-delete"
                                    @click="removeImpact(data.props.row)"
                                    :disable="
                                      formData.progressStatus == 'green'
                                    "
                                    size="md"
                                    class="float-right"
                                  >
                                    <q-tooltip
                                      content-class="bg-accent"
                                      :offset="[10, 10]"
                                    >
                                      Remove Impact
                                    </q-tooltip>
                                  </q-btn>
                                </q-td>
                              </template>
                            </data-table>
                          </div>
                        </div>
                        <div v-else>
                          <div
                            class="row q-col-gutter-x-md q-mb-sm items-center"
                          >
                            <div>
                              <q-btn flat @click="isAddingImpact = false">
                                <q-icon name="mdi-arrow-left"> </q-icon>
                              </q-btn>
                            </div>
                            <div class="title q-my-none q-mr-sm">
                              Estimated Impact
                            </div>
                          </div>
                          <div class="row q-col-gutter-y-lg">
                            <div class="col-12">
                              <q-select
                                :options="filteredOutcomesList"
                                v-model="selectedOutcome"
                                label="Outcome"
                                map-options
                                emit-value
                                option-value="id"
                                option-label="name"
                              >
                              </q-select>
                            </div>
                            <div class="col-12">
                              <q-select
                                label="Impact"
                                :options="rateOptions"
                                v-model="selectedOutcomeImpactRate"
                              >
                              </q-select>
                            </div>
                            <div class="col-12">
                              <q-btn
                                :disabled="
                                  !selectedOutcome || !selectedOutcomeImpactRate
                                "
                                color="primary"
                                class="float-right q-mt-sm"
                                @click="createImpact"
                              >
                                <q-icon name="mdi-plus-circle"> </q-icon>
                                <span class="sustainability-font q-mx-sm">
                                  Create
                                </span>
                              </q-btn>
                            </div>
                          </div>
                        </div>
                      </q-card-section>
                    </q-card>
                  </div>
                </div>
              </div>
            </div>
          </q-tab-panel>

          <!--ACTIONS-->
          <q-tab-panel name="actions">
            <div v-if="!isAddingAction">
              <div class="row q-mb-sm items-center">
                <div class="col-9">
                  <div class="row items-center q-col-gutter-x-md">
                    <div class="title q-my-none q-mx-none">
                      Actions
                      <!--Actions-->
                    </div>

                    <div>
                      <q-btn
                        color="primary"
                        @click="isAddingAction = true"
                        :disable="formData.progressStatus == 'green'"
                      >
                        <q-icon name="mdi-plus-circle"> </q-icon>
                        <span
                          class="sustainability-font q-mx-sm"
                          style="font-size: 13px"
                        >
                          Add
                        </span>
                      </q-btn>
                    </div>
                  </div>
                </div>
                <div class="col-3">
                  <q-input
                    class="searchbar float-right"
                    style="max-width: 70%"
                    filled
                    v-model="searchTextActions"
                    debounce="200"
                    label="Search"
                    clearable
                    dense
                  >
                    <template #prepend>
                      <q-icon name="mdi-magnify"></q-icon>
                    </template>
                  </q-input>
                </div>
              </div>
              <div class="row q-mt-lg">
                <div class="col-12">
                  <data-table
                    style="height: calc(100vh - 280px)"
                    flat
                    :data="actionsData"
                    :columns="actionsColumns"
                    headerBgColor="#162c47"
                    headerTextColor="white"
                    @rowDoubleClick="actionDoubleClick"
                  >
                    <template slot="body-cell-rank" slot-scope="data">
                      <q-td :props="data.props">
                        <q-input
                          class="actionRank-input"
                          v-model="data.props.row.rank"
                          @blur="saveAction(data.props.row)"
                          :disable="formData.progressStatus == 'green'"
                          dense
                          label="Rank"
                        >
                        </q-input>
                      </q-td>
                    </template>
                    <template slot="body-cell-actions" slot-scope="data">
                      <q-td :props="data.props">
                        <q-btn
                          round
                          color="red"
                          flat
                          icon="mdi-delete"
                          :disable="formData.progressStatus == 'green'"
                          @click="removeAction(data.props.row)"
                          size="md"
                          class="float-right"
                        >
                          <q-tooltip
                            content-class="bg-accent"
                            :offset="[10, 10]"
                          >
                            Remove Action
                          </q-tooltip>
                        </q-btn>
                      </q-td>
                    </template>
                  </data-table>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="row q-mb-sm items-center">
                <div class="col-9">
                  <div class="row items-center q-col-gutter-x-md">
                    <div>
                      <q-btn flat @click="backFromActionForm">
                        <q-icon name="mdi-arrow-left"> </q-icon>
                      </q-btn>
                    </div>
                    <div class="title q-my-none q-mx-none">Actions</div>
                  </div>
                </div>
              </div>
              <div class="row q-mt-lg">
                <div class="col-12">
                  <solutions-action-form
                    :disable="formData.progressStatus == 'green'"
                    :solutionTitle="formData.title"
                    @closeForm="backFromActionForm"
                  ></solutions-action-form>
                </div>
              </div>
            </div>
          </q-tab-panel>

          <!--FIND: WE RECOMMEND (FEATURED LISTING-->
          <q-tab-panel name="featuredListing">
            <featured-listing-tab></featured-listing-tab>
          </q-tab-panel>

          <!-- Find Default-->
          <q-tab-panel name="findDefault">
            <div class="row justify-center items-center">
              <div class="q-mr-md sustainability-font text-bold">
                Search for
              </div>
              <div>
                <q-form ref="findDefaultForm">
                  <q-input
                    placeholder="Type Here"
                    v-model="formData.findEntryDefault"
                    dense
                    style="width: 500px"
                  >
                  </q-input>
                </q-form>
              </div>
              <div class="q-ml-md sustainability-font text-bold">
                in my area
              </div>
            </div>
            <div class="row justify-center">
              <span class="text-caption text-grey-6">
                This is displayed when there is no entry data saved
              </span>
            </div>
            <div class="row justify-end">
              <q-btn
                color="primary"
                @click="saveSolution()"
                class="float-right q-mt-sm"
              >
                <q-icon name="mdi-plus-circle" class="q-mr-sm"> </q-icon>
                <span
                  class="sustainability-font q-mx-sm"
                  style="font-size: 13px"
                >
                  Save
                </span>
              </q-btn>
            </div>
          </q-tab-panel>

          <!--FIND------------>
          <q-tab-panel name="find">
            <div v-if="!isAddingFindEntry && !isUpdatingFindEntry">
              <div class="row q-mb-sm items-center">
                <div class="col-9">
                  <div class="row items-center q-col-gutter-x-md">
                    <div class="title q-my-none q-mx-none">Find</div>

                    <div>
                      <q-btn color="primary" @click="isAddingFindEntry = true">
                        <q-icon name="mdi-plus-circle"> </q-icon>
                        <span
                          class="sustainability-font q-mx-sm"
                          style="font-size: 13px"
                        >
                          Add
                        </span>
                      </q-btn>
                    </div>
                  </div>
                </div>
                <div class="col-3">
                  <q-input
                    class="searchbar float-right"
                    style="max-width: 70%"
                    filled
                    v-model="searchTextFindEntries"
                    debounce="200"
                    label="Search"
                    clearable
                    dense
                  >
                    <template #prepend>
                      <q-icon name="mdi-magnify"></q-icon>
                    </template>
                  </q-input>
                </div>
              </div>
              <div class="row q-mt-lg">
                <div class="col-12">
                  <data-table
                    style="height: calc(100vh - 280px)"
                    flat
                    :data="findEntriesData"
                    :columns="findEntriesColumns"
                    headerBgColor="#162c47"
                    headerTextColor="white"
                    @rowDoubleClick="findEntryDoubleClick"
                  >
                    <template slot="body-cell-rank" slot-scope="data">
                      <q-td :props="data.props">
                        <q-input
                          class="actionRank-input"
                          v-model="data.props.row.rank"
                          :disable="formData.progressStatus == 'green'"
                          @blur="saveFindEntry(data.props.row)"
                          dense
                          label="Rank"
                        >
                        </q-input>
                      </q-td>
                    </template>
                    <template slot="body-cell-actions" slot-scope="data">
                      <q-td :props="data.props">
                        <q-btn
                          round
                          color="red"
                          flat
                          icon="mdi-delete"
                          :disable="formData.progressStatus == 'green'"
                          @click="removeFindEntry(data.props.row)"
                          size="md"
                          class="float-right"
                        >
                          <q-tooltip
                            content-class="bg-accent"
                            :offset="[10, 10]"
                          >
                            Remove Find Entry
                          </q-tooltip>
                        </q-btn>
                      </q-td>
                    </template>
                  </data-table>
                </div>
              </div>
            </div>

            <div v-else-if="isAddingFindEntry || isUpdatingFindEntry">
              <div class="row q-mb-sm items-center">
                <div class="col-9">
                  <div class="row items-center q-col-gutter-x-md">
                    <div>
                      <q-btn flat @click="backFromFindEntryForm">
                        <q-icon name="mdi-arrow-left"> </q-icon>
                      </q-btn>
                    </div>
                    <div class="title q-my-none q-mx-none">Find</div>
                  </div>
                </div>
              </div>
              <q-form ref="findEntryForm">
                <div class="row q-mt-lg q-col-gutter-md">
                  <div class="col-4">
                    <q-input
                      v-model="findEntriesFormData.productService"
                      label="Product / Service"
                      :rules="[(v) => !!v || 'Field is Required']"
                    >
                    </q-input>
                  </div>
                  <div class="col-4">
                    <q-input
                      v-model="findEntriesFormData.supplierName"
                      :rules="[(v) => !!v || 'Field is Required']"
                      label="Supplier Name"
                    >
                    </q-input>
                  </div>
                  <div class="col-4">
                    <q-select
                      v-model="findEntriesFormData.serviceArea"
                      label="New Zealand Service Area"
                      use-input
                      @filter="filterRegions"
                      :rules="[(v) => !!v || 'Field is Required']"
                      :options="filteredRegions"
                    >
                      <template v-slot:no-option>
                        <q-item>
                          <q-item-section class="text-grey">
                            No results
                          </q-item-section>
                        </q-item>
                      </template>
                    </q-select>
                  </div>
                  <div class="col-6">
                    <q-input v-model="findEntriesFormData.url" label="URL">
                    </q-input>
                  </div>
                  <div class="col-12">
                    <q-btn
                      v-if="!isUpdatingFindEntry"
                      color="primary"
                      @click="createFindEntry"
                      class="float-right q-mt-sm"
                      :disable="formData.progressStatus == 'green'"
                    >
                      <q-icon name="mdi-plus-circle" class="q-mr-sm"> </q-icon>
                      <span
                        class="sustainability-font q-mx-sm"
                        style="font-size: 13px"
                      >
                        Create
                      </span>
                    </q-btn>
                    <q-btn
                      v-else
                      color="primary"
                      @click="saveFindEntry()"
                      class="float-right q-mt-sm"
                    >
                      <q-icon name="mdi-plus-circle" class="q-mr-sm"> </q-icon>
                      <span
                        class="sustainability-font q-mx-sm"
                        style="font-size: 13px"
                      >
                        Save
                      </span>
                    </q-btn>
                  </div>
                </div>
              </q-form>
            </div>
          </q-tab-panel>

          <!--Outcome-->
          <q-tab-panel name="Outcome"> </q-tab-panel>

          <!--SOURCES-->
          <q-tab-panel name="sources">
            <div class="row q-mb-sm items-center">
              <div class="col-9">
                <div class="row items-center q-col-gutter-x-md">
                  <div class="title q-my-none q-mx-none">Sources</div>

                  <div style="width: 200px">
                    <q-form ref="sourceForm">
                      <!-- <Autocomplete
                        label="Add Source"
                        option-label="name"
                        :options="filteredSourcesList"
                        :hideBottomSpace="true"
                        dense

                      ></Autocomplete> -->
                      <q-select
                        v-model="selectedSource"
                        label="Add Source"
                        use-input
                        color="accent"
                        @filter="filterSource"
                        :options="filteredSourcesList"
                        dense
                        emit-value
                        hide-bottom-space
                        option-label="name"
                      >
                        <template v-slot:no-option>
                          <q-item>
                            <q-item-section class="text-grey">
                              No results
                            </q-item-section>
                          </q-item>
                        </template>
                      </q-select>
                    </q-form>
                  </div>
                  <div>
                    <q-btn
                      :disabled="!selectedSource"
                      color="primary"
                      @click="createSource"
                    >
                      <q-icon name="mdi-plus-circle"> </q-icon>
                      <span class="sustainability-font q-mx-sm"> Add </span>
                    </q-btn>
                  </div>
                </div>
              </div>
              <div class="col-3">
                <q-input
                  class="searchbar float-right"
                  style="max-width: 70%"
                  filled
                  v-model="searchTextSources"
                  debounce="200"
                  label="Search"
                  clearable
                  dense
                >
                  <template #prepend>
                    <q-icon name="mdi-magnify"></q-icon>
                  </template>
                </q-input>
              </div>
            </div>

            <div class="row q-mt-lg">
              <div class="col-12">
                <data-table
                  style="height: calc(100vh - 280px)"
                  flat
                  :filter="searchTextSources"
                  :data="sourcesData"
                  :columns="sourcesColumns"
                  headerBgColor="#162c47"
                  headerTextColor="white"
                >
                  <template slot="body-cell-outcomes" slot-scope="data">
                    <q-td :props="data.props">
                      <q-img
                        v-for="(outcome, i) in data.props.row.outcomes"
                        :key="i"
                        :src="returnOutcomeImage(outcome)"
                        style="width: 30px; height: 30px; margin-right: 5px"
                      >
                      </q-img>
                    </q-td>
                  </template>
                  <template slot="body-cell-actions" slot-scope="data">
                    <q-td :props="data.props">
                      <q-btn
                        round
                        color="red"
                        flat
                        :disable="formData.progressStatus == 'green'"
                        icon="mdi-delete"
                        @click="removeSources(data.props.row)"
                        size="md"
                        class="float-right"
                      >
                        <q-tooltip content-class="bg-accent" :offset="[10, 10]">
                          Remove Source
                        </q-tooltip>
                      </q-btn>
                    </q-td>
                  </template>
                </data-table>
              </div>
            </div>
          </q-tab-panel>
          <!--Articles-->
          <q-tab-panel name="articles">
            <div v-if="!isAddingArticle">
              <div class="row q-mb-sm items-center">
                <div class="col-9">
                  <div class="row items-center q-col-gutter-x-md">
                    <div class="title q-my-none q-mx-none">Article Tagging</div>
                    <div>
                      <q-btn color="primary" @click="isAddingArticle = true">
                        <q-icon name="mdi-plus-circle"> </q-icon>
                        <span class="sustainability-font q-mx-sm"> Add </span>
                      </q-btn>
                    </div>
                  </div>
                </div>
                <div class="col-3">
                  <q-input
                    class="searchbar float-right"
                    style="max-width: 70%"
                    filled
                    v-model="searchTextArticles"
                    debounce="200"
                    label="Search"
                    clearable
                    dense
                  >
                    <template #prepend>
                      <q-icon name="mdi-magnify"></q-icon>
                    </template>
                  </q-input>
                </div>
              </div>
              <div class="row q-mt-lg">
                <div class="col-12">
                  <data-table
                    style="height: calc(100vh - 280px)"
                    flat
                    :data="articlesData"
                    :columns="articlesColumns"
                    headerBgColor="#162c47"
                    headerTextColor="white"
                    @rowDoubleClick="articleDoubleClick"
                  >
                    <template slot="body-cell-actions" slot-scope="data">
                      <q-td :props="data.props">
                        <q-btn
                          round
                          color="red"
                          flat
                          icon="mdi-delete"
                          :disable="formData.progressStatus == 'green'"
                          @click="removeArticle(data.props.row)"
                          size="md"
                          class="float-right"
                        >
                          <q-tooltip
                            content-class="bg-accent"
                            :offset="[10, 10]"
                          >
                            Remove Action
                          </q-tooltip>
                        </q-btn>
                      </q-td>
                    </template>
                  </data-table>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="row q-mb-sm items-center">
                <div class="col-9">
                  <div class="row items-center q-col-gutter-x-md">
                    <div>
                      <q-btn flat @click="backFromArticleForm">
                        <q-icon name="mdi-arrow-left"> </q-icon>
                      </q-btn>
                    </div>
                    <div class="title q-my-none q-mx-none">Extra Insights</div>
                  </div>
                </div>
              </div>
              <div class="row q-mt-lg">
                <div class="col-12">
                  <!--FORM GOES HERE-->
                  <extra-insights-form
                    @closeForm="backFromArticleForm"
                  ></extra-insights-form>
                </div>
              </div>
            </div>
          </q-tab-panel>
        </q-tab-panels>
      </q-card-section>
    </q-card>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import DataTable from "@/components/datatable/datatable.vue";
  import Autocomplete from "@/components/autocomplete/autocomplete.vue";
  import solutionsActionForm from "@/components/solutions/actions/solutionsActionForm.vue";
  import extraInsightsForm from "@/components/solutions/extraInsights/extraInsightsForm.vue";
  import FeaturedListingTab from "@/components/solutions/featuredListingTab/featuredListingTab.vue";

  export default {
    components: {
      DataTable,
      solutionsActionForm,
      Autocomplete,
      extraInsightsForm,
      FeaturedListingTab,
    },
    computed: {
      ...mapGetters({
        data: "solutions/selectedSolution",
        actionsData: "solutions/actions/list",
        sourcesData: "solutions/solutionsSourcesList",
        findEntriesData: "solutions/findEntries/list",
        sources: "sources/list",
        outcomesList: "outcomes/list",
        solutionsImpactList: "solutions/solutionsImpactList",
        selectedFindEntry: "solutions/findEntries/selectedFindEntry",
        currentUserData: "auth/currentUserData",
        articlesData: "solutions/articles/list",
      }),
      //articles columns
      articlesColumns() {
        return [
          {
            name: "id",
            label: "ID",
            align: "left",
            field: "id",
            style:
              "min-width: 80px;max-width: 80px;width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          },
          {
            name: "url",
            label: "Url",
            align: "left",
            field: "url",
            style:
              "min-width: 400px;max-width: 400px;width: 400px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          },
          {
            name: "articlesID",
            label: "Article",
            align: "left",
            field: "title",
            style:
              "min-width: 400px;max-width: 400px;width: 400px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          },
          {
            name: "actions",
            label: "Actions",
            align: "right",
            field: "delete",
            style:
              "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          },
        ];
      },
      //actions table
      actionsColumns() {
        return [
          {
            name: "id",
            label: "ID",
            align: "left",
            field: "id",
            style:
              "min-width: 80px;max-width: 80px;width: 80px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          },
          {
            name: "rank",
            label: "Rank",
            align: "left",
            field: "rank",
            style:
              "min-width:30px;max-width: 30px;width: 30px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          },
          {
            name: "description",
            label: "Description",
            align: "left",
            field: "description",
            style:
              "min-width:300px;max-width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          },
          {
            name: "createdAt",
            label: "Created At",
            align: "right",
            field: "created_at",
            format: (val) => this.$options.filters.gridDateFormat(val),
            style:
              "min-width: 110px;max-width: 110px;width: 110px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          },
          {
            name: "actions",
            label: "Actions",
            align: "right",
            field: "delete",
            style:
              "min-width: 80px;max-width: 80px;width: 80px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          },
        ];
      },

      //sources table
      sourcesColumns() {
        return [
          {
            name: "id",
            label: "ID",
            align: "left",
            field: "id",
            style:
              "min-width: 80px;max-width: 80px;width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          },
          {
            name: "name",
            label: "Source Name",
            align: "left",
            field: "sourceName",
            style:
              "min-width: 300px;max-width: 300px;width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          },
          {
            name: "outcomes",
            label: "Outcomes",
            align: "left",
            field: "outcomes",
            style:
              "min-width: 300px;max-width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          },
          {
            name: "createdAt",
            label: "Created At",
            align: "left",
            field: "created_at",
            format: (val) => this.$options.filters.gridDateFormat(val),
            style:
              "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          },
          {
            name: "actions",
            label: "Actions",
            align: "right",
            field: "delete",
            style:
              "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          },
        ];
      },
      //solutions impact table
      solutionsImpactColumns() {
        return [
          {
            name: "id",
            label: "ID",
            align: "left",
            field: "id",
            style:
              "min-width: 20px;max-width: 20px;width: 20px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          },
          {
            name: "outcomesName",
            label: "Outcome Name",
            align: "left",
            field: "name",
            style:
              "min-width: 200px;max-width: 200px;width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          },
          {
            name: "impact",
            label: "Impact",
            align: "left",
            field: "impact",
            style:
              "min-width:100px;max-width:100px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          },
          {
            name: "rank",
            label: "Rank",
            align: "left",
            field: "renk",
            style:
              "min-width:100px;max-width:100px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          },
          {
            name: "actions",
            label: "Actions",
            align: "right",
            field: "delete",
            style:
              "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          },
        ];
      },

      //find entries table
      findEntriesColumns() {
        return [
          {
            name: "id",
            label: "ID",
            align: "left",
            field: "id",
            style:
              "min-width: 80px;max-width: 80px;width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
          },
          {
            name: "rank",
            label: "Rank",
            align: "left",
            field: "rank",
            style:
              "min-width: 80px;max-width: 80px;width: 300px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
          },
          {
            name: "productService",
            label: "Product / Service",
            align: "left",
            field: "productService",
            style:
              "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
            sortable: true,
          },
          {
            name: "supplierName",
            label: "Supplier Name",
            align: "left",
            field: "supplierName",
            sortable: true,
          },
          {
            name: "serviceArea",
            label: "Service Area",
            align: "left",
            field: "serviceArea",
            sortable: true,
          },
          {
            name: "createdAt",
            label: "Created At",
            align: "left",
            field: "created_at",
            format: (val) => this.$options.filters.gridDateFormat(val),
            sortable: true,
          },

          {
            name: "actions",
            label: "Actions",
            align: "right",
            field: "delete",
            style:
              "min-width: 150px;max-width: 150px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;",
          },
        ];
      },

      filteredSourcesList() {
        let filteredSources = this.sourcesOptions;
        filteredSources = filteredSources.filter((e) => {
          if (this.sourcesData.findIndex((os) => e.id == os.sourceId) < 0) {
            return e;
          }
        });
        return filteredSources;
      },
      filteredOutcomesList() {
        return this.outcomesList.filter((e) => {
          return (
            this.solutionsImpactList.findIndex((si) => si.outcomes_id == e.id) <=
            -1
          );
        });
      },
    },
    watch: {
      data: {
        deep: true,
        handler() {
          this.init();
        },
      },
      sources: {
        deep: true,
        handler() {
          this.sourcesOptions = this.sources;
        },
      },
      $route: {
        handler() {
          this.handleRoute();
        },
        deep: true,
      },
    },
    data: () => ({
      //solution card title
      solutionCardTitle: "",
      isLoading: false,

      //tabs
      tab: "",
      tabsList: [
        {
          name: "general",
          label: "Info",
          isError: false,
        },

        {
          name: "actions",
          label: "Actions",
          isError: false,
        },
        {
          name: "findDefault",
          label: "Find: Search Online",
          isError: false,
        },
        {
          name: "find",
          label: "Find: Suppliers",
          isError: false,
        },
        {
          name: "featuredListing",
          label: "Find: We Recommend",
          isError: false,
        },

        {
          name: "Outcome",
          label: "Outcome",
          isError: false,
        },
        {
          name: "sources",
          label: "Source Tagging",
          isError: false,
        },
        {
          name: "articles",
          label: "Article Tagging",
          isError: false,
        },
      ],

      //source table
      searchTextSources: "",

      //action table
      searchTextActions: "",

      //find entry table
      searchTextFindEntries: "",

      // soluton form
      formData: {
        title: "",
        description: "",
        imageUrl: "",
        progressStatus: "purple",
        quickWin: 0,
        hideFindTab: 0,
      },
      filteredIndustryOptions: [],
      filteredAreaOfBizOptions: [],
      industryOptions: [
        "Accommodation and Food Services",
        "Agriculture, Forestry and Fishing",
        "Arts and Recreation Services",
        "Construction",
        "Education and Training",
        "Electricity, Gas, Water and Waste Services",
        "Financial, Insurance & Administration Services",
        "Health Care and Social Assistance",
        "Information Media and Telecommunications",
        "Manufacturing",
        "Mining",
        "Professional, Scientific and Technical Services",
        "Rental, Hiring and Real Estate Services",
        "Retail Trade",
        "Transport, Postal and Warehousing",
        "Wholesale Trade",
        "Other",
      ],
      isSelectAllIndustries: false,
      isSelectAllAreaOfBiz: false,
      areaOfBizOptions: [
        "Vehicles & Transport",
        "Shipping & Exporting",
        "Office & Building",
        "Sites & Projects",
        "Materials, Products & Assets",
        "Leadership & Strategy",
        "Environment-Related",
        "Other",
      ],
      progressStatusOptions: [
        {
          color: "purple",
          description: "Text or Questions are needed",
          label: "Purple",
        },
        {
          color: "red",
          description: "Ready for revision",
          label: "Red",
        },
        {
          color: "orange",
          description: "Image needs replacing",
          label: "Orange",
        },
        {
          color: "green",
          description: "Complete and live",
          label: "Green",
        },
      ],

      imageStatusOptions: [
        {
          color: "purple",
          description: "Needing Image",
          label: "Purple",
        },
        {
          color: "blue",
          description: "Image needs checking",
          label: "Blue",
        },
        {
          color: "orange",
          description: "Image needs replacing",
          label: "Orange",
        },
        {
          color: "red",
          description: "Image needs re-checking",
          label: "Red",
        },
        {
          color: "green",
          description: "Image approved",
          label: "Green",
        },
      ],

      //action form
      isAddingAction: false,
      actionFormData: {
        title: "",
        description: "",
      },

      //sourceForm
      selectedSource: null,
      sourcesOptions: [],

      //options for cost, ease of action, and impact
      rateOptions: ["Low", "Moderate", "High"],

      //impactOutcome form
      selectedOutcome: null,
      selectedOutcomeImpactRate: null,
      isAddingImpact: false,

      //find entry form
      findEntriesFormData: {},
      isAddingFindEntry: false,
      isUpdatingFindEntry: false,
      filteredRegions: [], // for service area dropdown
      regions: [
        "Nationwide",
        "Auckland",
        "Bay Of Plenty",
        "Canterbury",
        "Gisborne",
        "Hawke's Bay",
        "Manawatu/Whanganui",
        "Marlborough",
        "Nelson/Tasman",
        "Northland",
        "Otago",
        "Southland",
        "Taranaki",
        "Waikato",
        "Wellington",
        "West Coast",
        "North Island",
        "South Island",
      ],

      //croppa
      myCroppa: {},
      changeImage: false,

      //extra insights / articles
      isAddingArticle: false,
      searchTextArticles: "",
    }),
    async mounted() {
      if (this.$route.name == "solutionsView") {
        await this.tabTraversal();
      }
      this.handleRoute();
      this.init();
    },
    methods: {
      lockWarning(value) {
        if (value == "green") {
          this.$swal({
            title: "Warning",
            text: "Marking this complete will lock Info, Actions and Source Tagging permanently",
            type: "warning",
            confirmButtonText: "Confirm",
            cancelButtonText: "Cancel",
            showCancelButton: true,
            confirmButtonColor: "#f58122",
          }).then(async (res) => {
            if (res.value) {
              this.formData.progressStatus = "green";
            } else {
              this.formData.progressStatus = "red";
            }
          });
        } else {
          this.formData.progressStatus = value;
        }
      },
      returnOutcomeImage(outcome) {
        switch (outcome.name) {
          case "Carbon Emissions":
            return "/statics/outcomes/Carbon - Full Colour.svg";
          case "Waste":
            return "/statics/outcomes/Waste - Full Colour.svg";
          case "Energy":
            return "/statics/outcomes/Energy - Full Colour.svg";
          case "Water":
            return "/statics/outcomes/Water - Full Colour.svg";
          case "Use SME's":
            return "/statics/outcomes/SME - Full Colour.svg";
          case "Use Local":
            return "/statics/outcomes/Using Local - Full Colour.svg";
          case "Charitable":
            return "/statics/outcomes/NFP - Full Colour.svg";
          case "Social Procurement":
            return "/statics/outcomes/Social Enterprise - Full Colour.svg";
        }
      },
      async handleRoute() {
        if (this.$route.params.hasOwnProperty("findEntriesID")) {
          await this.tabTraversal();
          this.initialiseFindEntryData();
        }
        if (this.$route.params.hasOwnProperty("actionsID")) {
          await this.tabTraversal();
          this.isAddingAction = true;
          this.$refs.tabs.goTo("actions");
        }
        if (this.$route.params.hasOwnProperty("articlesID")) {
          await this.tabTraversal();
          this.isAddingArticle = true;
          this.$refs.tabs.goTo("articles");
        }
        if (this.$route.params.hasOwnProperty("featuredFindEntry_id")) {
          await this.tabTraversal();
          this.$refs.tabs.goTo("featuredListing");
        }
      },
      async tabTraversal() {
        let tabNames = ["general", "outcomes"];
        await tabNames.reduce((promiseChain, item) => {
          return promiseChain.then(
            () =>
              new Promise((resolve) => {
                resolve();
                this.$refs.tabs.goTo(item);
              })
          );
        }, Promise.resolve());

        this.$refs.tabs.goTo("general");
      },
      selectAllAreaOfBiz() {
        this.formData.areaOfBusiness = [...this.areaOfBizOptions];
      },
      selectAllIndustries() {
        this.formData.industry = [...this.industryOptions];
      },
      initialiseFindEntryData() {
        if (this.$route.params.hasOwnProperty("findEntriesID")) {
          this.$refs.tabs.goTo("find");
          this.$store
            .dispatch(
              "solutions/findEntries/loadFindEntryByID",
              this.$route.params.findEntriesID
            )
            .then(() => {
              this.findEntriesFormData = this.selectedFindEntry;
            });
          this.isUpdatingFindEntry = true;
        }
      },
      backFromFindEntryForm() {
        if (this.$route.name != "solutionsView") {
          this.$router.push("/solutions/" + this.$route.params.id);
        }
        this.findEntriesFormData = {};
        this.isAddingFindEntry = false;
        this.isUpdatingFindEntry = false;
        this.$store.commit("solutions/findEntries/setSelectedFindEntry", null);
      },
      backFromArticleForm() {
        if (this.$route.name != "solutionsView") {
          this.$router.push("/solutions/" + this.$route.params.id);
        }
        this.isAddingArticle = false;
        //  this.$store.commit("solutions/findEntries/setSelectedFindEntry", null);
      },
      backFromActionForm() {
        if (this.$route.name != "solutionsView") {
          this.$router.push("/solutions/" + this.$route.params.id);
        }
        this.isAddingAction = false;
        this.$store.commit("solutions/articles/setSelectedArticle", null);
      },
      init() {
        if (this.data != null) {
          this.formData = JSON.parse(JSON.stringify(this.data));
          if (this.data.title) {
            this.solutionCardTitle = this.data.title;
          }
          if (this.data.industry) {
            this.formData["industry"] = JSON.parse(this.data.industry);
          }
          if (this.data.areaOfBusiness) {
            this.formData["areaOfBusiness"] = JSON.parse(
              this.data.areaOfBusiness
            );
          }

          if (this.formData.status == "temp") {
            this.formData.progressStatus = "purple";
            this.formData.status = "draft";
          }
        }
      },
      changeSolutionCardTitle(val) {
        this.solutionCardTitle = val;
      },
      filterSource(val, update, abort) {
        update(() => {
          const source = val.toLowerCase();
          this.sourcesOptions = this.sources.filter(
            (s) => s.name.toLowerCase().indexOf(source) > -1
          );
        });
      },
      closeDialog() {
        this.$store.commit("solutions/setSelectedSolution", null);
        this.$router.push("/solutions");
        this.$emit("closeDialog");
      },
      filterIndustry(val, update) {
        update(() => {
          if (val === "") {
            this.filteredIndustryOptions = this.industryOptions;
          } else {
            const input = val.toLowerCase();
            this.filteredIndustryOptions = this.industryOptions.filter(
              (e) => e.toLowerCase().indexOf(input) > -1
            );
          }
        });
      },
      filterRegions(val, update) {
        update(() => {
          if (val === "") {
            this.filteredRegions = this.regions;
          } else {
            const input = val.toLowerCase();
            this.filteredRegions = this.regions.filter(
              (e) => e.toLowerCase().indexOf(input) > -1
            );
          }
        });
      },
      filterAreaOfBiz(val, update) {
        update(() => {
          if (val === "") {
            this.filteredAreaOfBizOptions = this.areaOfBizOptions;
          } else {
            const input = val.toLowerCase();
            this.filteredAreaOfBizOptions = this.areaOfBizOptions.filter(
              (e) => e.toLowerCase().indexOf(input) > -1
            );
          }
        });
      },
      async createImpact() {
        let result = await this.$store.dispatch("solutions/newSolutionsImpact", {
          outcomes_id: this.selectedOutcome,
          solutions_id: this.data.id,
          impact: this.selectedOutcomeImpactRate,
        });
        if (result.Result == "Success") {
          this.$q.notify({
            position: "top-right",
            type: "positive",
            message: result.Response.Message,
          });
          this.selectedOutcome = "";
          this.selectedOutcomeImpactRate = "";
          this.isAddingImpact = false;
        } else {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an Error, Please try again later",
          });
        }
      },

      async createSource() {
        const isValid = await this.$refs.sourceForm.validate();

        if (isValid) {
          let result = await this.$store.dispatch("solutions/newSource", {
            sources_id: this.selectedSource.id,
            solutions_id: this.$route.params.id,
          });

          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message,
            });
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }
          this.selectedSource = null;
          await this.$refs.sourceForm.reset();
        }
      },
      async createAction() {
        const isValid = await this.$refs.actionForm.validate();
        if (isValid) {
          let result = await this.$store.dispatch("solutionsActions/new", {
            ...this.actionFormData,
            solutions_id: this.$route.params.id,
          });

          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message,
            });

            this.actionFormData = {
              title: "",
              description: "",
            };
            await this.$refs.actionForm.reset();
            this.isAddingAction = false;
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }
        }
      },
      async createFindEntry() {
        const isValid = await this.$refs.findEntryForm.validate();
        if (isValid) {
          let result = await this.$store.dispatch("solutions/findEntries/new", {
            ...this.findEntriesFormData,
            solutions_id: this.data.id,
          });
          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message,
            });

            this.findEntriesFormData = {};
            await this.$refs.findEntryForm.reset();
            this.isAddingFindEntry = false;
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }
        }
      },
      onImpactFieldBlur(updatedImpact) {
        this.saveImpact(updatedImpact, false);
      },
      removeImpact(impact) {
        this.$swal({
          title: "Warning",
          text: "You are about to delete this Item. This is irreversible",
          type: "warning",
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          showCancelButton: true,
          confirmButtonColor: "#f58122",
        }).then(async (res) => {
          if (res.value) {
            this.saveImpact(impact, true);
          }
        });
      },
      removeSources(source) {
        this.$swal({
          title: "Warning",
          text: "You are about to delete this Item. This is irreversible",
          type: "warning",
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          showCancelButton: true,
          confirmButtonColor: "#f58122",
        }).then(async (res) => {
          if (res.value) {
            let payload = {
              deleted_at: new Date(),
              ...source,
              solutions_id: this.$route.params.id,
            };
            this.$store
              .dispatch("solutions/saveSource", payload)
              .then((result) => {
                if (result.Result == "Success") {
                  this.$q.notify({
                    position: "top-right",
                    type: "positive",
                    message: "The Source has been removed.",
                  });
                } else {
                  this.$q.notify({
                    position: "top-right",
                    type: "negative",
                    message: "There was an Error, Please try again later",
                  });
                }
              });
          }
        });
      },
      removeArticle(article) {
        this.$swal({
          title: "Warning",
          text: "You are about to delete this Item. This is irreversible",
          type: "warning",
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          showCancelButton: true,
          confirmButtonColor: "#f58122",
        }).then(async (res) => {
          if (res.value) {
            let payload = { ...article };
            payload["deleted_at"] = 1;

            this.$store
              .dispatch("solutions/articles/save", payload)
              .then((result) => {
                if (result.Result == "Success") {
                  this.$q.notify({
                    position: "top-right",
                    type: "positive",
                    message: "The Action has been removed.",
                  });
                } else {
                  this.$q.notify({
                    position: "top-right",
                    type: "negative",
                    message: "There was an Error, Please try again later",
                  });
                }
              });
          }
        });
      },
      removeAction(action) {
        this.$swal({
          title: "Warning",
          text: "You are about to delete this Item. This is irreversible",
          type: "warning",
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          showCancelButton: true,
          confirmButtonColor: "#f58122",
        }).then(async (res) => {
          if (res.value) {
            let payload = { ...action };
            payload["deleted_at"] = 1;

            this.$store
              .dispatch("solutions/actions/save", payload)
              .then((result) => {
                if (result.Result == "Success") {
                  this.$q.notify({
                    position: "top-right",
                    type: "positive",
                    message: "The Action has been removed.",
                  });
                } else {
                  this.$q.notify({
                    position: "top-right",
                    type: "negative",
                    message: "There was an Error, Please try again later",
                  });
                }
              });
          }
        });
      },
      async saveAction(action) {
        if (!isNaN(action.rank)) {
          this.$store
            .dispatch("solutions/actions/save", action)
            .then((result) => {
              if (result.Result == "Success") {
                this.$q.notify({
                  position: "top-right",
                  type: "positive",
                  message: "The Action has been removed.",
                });
              } else {
                this.$q.notify({
                  position: "top-right",
                  type: "negative",
                  message: "There was an Error, Please try again later",
                });
              }
            });
        } else {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "Rank must be a number.",
          });
        }
      },
      removeFindEntry(findEntry) {
        this.$swal({
          title: "Warning",
          text: "You are about to delete this Item. This is irreversible",
          type: "warning",
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          showCancelButton: true,
          confirmButtonColor: "#f58122",
        }).then(async (res) => {
          if (res.value) {
            this.saveFindEntry(findEntry, true);
          }
        });
      },
      async saveFindEntry(findEntry, isDelete = false) {
        let payload = {};
        if (isDelete) {
          payload = {
            deleted_at: new Date(),
            id: findEntry.id,
            solutions_id: findEntry.solutions_id,
          };
        } else {
          if (this.findEntriesFormData.hasOwnProperty("id")) {
            payload = {
              id: this.selectedFindEntry.id,
              ...this.findEntriesFormData,
            };
          } else {
            payload = { ...findEntry };
          }
        }
        let result = await this.$store.dispatch(
          "solutions/findEntries/save",
          payload
        );
        if (result.Result == "Success") {
          this.$q.notify({
            position: "top-right",
            type: "positive",
            message: result.Response.Message,
          });
          this.findEntriesFormData = {};
          if (!isDelete) {
            this.backFromFindEntryForm();
          }
        } else {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an Error, Please try again later",
          });
        }
      },

      async saveImpact(impact, isDelete) {
        let payload = {
          impact: impact.impact,
          id: impact.id,
          solutions_id: impact.solutions_id,
          rank: impact.rank,
        };
        if (isDelete) {
          payload["deleted_at"] = new Date();
        }
        let result = await this.$store.dispatch(
          "solutions/saveSolutionsImpact",
          payload
        );
        if (result.Result == "Success") {
          this.$q.notify({
            position: "top-right",
            type: "positive",
            message: result.Response.Message,
          });
          this.selectedOutcome = "";
          this.selectedOutcomeImpactRate = "";
        } else {
          this.$q.notify({
            position: "top-right",
            type: "negative",
            message: "There was an Error, Please try again later",
          });
        }
      },
      async saveSolution(isClose = false) {
        let index = this.tabsList.findIndex((e) => e.name == "general");
        const isValid = await this.$refs.form.validate();
        if (isValid) {
          if (index > -1) {
            this.tabsList[index].isError = false;
          }

          let payload = { ...this.formData };
          if (
            payload.findEntryDefault == "" ||
            payload.findEntryDefault == null
          ) {
            payload.findEntryDefault = payload.title;
          }

          //image uploading
          if (this.myCroppa && this.myCroppa.imageSet) {
            payload.image = {
              dataUrl: this.myCroppa.generateDataUrl(),
            };
            this.formData.imageStatus =
              this.formData.imageStatus == "purple" ? "blue" : "red";
          } else {
            delete payload.image;
          }

          payload.industry = JSON.stringify(this.formData.industry);
          payload.areaOfBusiness = JSON.stringify(this.formData.areaOfBusiness);

          let result = await this.$store.dispatch("solutions/save", {
            ...payload,
            id: this.$route.params.id,
            status: "live",
          });

          if (result.Result == "Success") {
            this.$q.notify({
              position: "top-right",
              type: "positive",
              message: result.Response.Message,
            });
            if (isClose) {
              this.closeDialog();
            }
          } else {
            this.$q.notify({
              position: "top-right",
              type: "negative",
              message: "There was an Error, Please try again later",
            });
          }
        } else {
          if (index > -1) {
            this.tabsList[index].isError = true;
          }
        }
      },
      findEntryDoubleClick(row) {
        this.$router.push(
          "/solutions/" + this.data.id + "/findEntries/" + row.id
        );
      },
      actionDoubleClick(row) {
        this.$router.push("/solutions/" + this.data.id + "/actions/" + row.id);
      },
      articleDoubleClick(row) {
        this.$router.push("/solutions/" + this.data.id + "/articles/" + row.id);
      },
      async saveAndAddNew() {
        this.isLoading = true;
        await this.saveSolution();
        let result = await this.$store.dispatch("solutions/new", {
          status: "temp",
        });
        let id = result.Response.newSolutionId;
        this.$router.push("/solutions/" + parseFloat(id));
        this.$store.dispatch("outcomes/loadAll");
        this.$store.dispatch("sources/loadAll");
        await Promise.all([
          this.$store.dispatch("solutions/actions/loadAllBySolutionID", id),
          this.$store.dispatch(
            "solutions/loadAllSolutionsSourcesBySolutionID",
            id
          ),
          this.$store.dispatch("solutions/loadSolutionsImpactBySolutionID", id),
          this.$store.dispatch("solutions/loadSolutionByID", id),
        ]);
        this.init();
        this.tab = "general";
        this.isLoading = false;
      },
    },
  };
</script>
<style lang="scss" scoped>
  .title {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 13px;
  }

  .sustainability-button {
    min-width: 151px;
    height: 34px;
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 600;
    font-size: 9px;
    line-height: 11px;
    display: flex;
    align-items: center;
    text-align: center;
  }

  .sustainability-font {
    font-family: "Montserrat";
    font-style: normal;
    font-weight: 500;
  }

  .tabTitle {
    font-weight: bold;
  }

  .actionRank-input >>> input[type="number"] {
    -moz-appearance: textfield !important;
  }

  .actionRank-input >>> input::-webkit-outer-spin-button,
  .actionRank-input >>> input::-webkit-inner-spin-button {
    appearance: none !important;
    -webkit-appearance: none !important;
    -moz-appearance: none !important;
  }
</style>
